import { render, staticRenderFns } from "./Email.vue?vue&type=template&id=8f50e5de&scoped=true&"
import script from "./Email.vue?vue&type=script&lang=js&"
export * from "./Email.vue?vue&type=script&lang=js&"
import style0 from "./Email.vue?vue&type=style&index=0&id=8f50e5de&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f50e5de",
  null
  
)

export default component.exports